<div class="mx-auto my-4 w-full max-w-[800px] px-4 md:w-4/5">
  <app-forgot-password></app-forgot-password>
</div>
